export const defaultSingpassManualDataPayload = {
    "code": 0,
    "person": {
      "uinfin": {
        "lastupdated": "2023-03-16",
        "source": "1",
        "classification": "C",
        "value": "" 
      },
      "name": {
        "lastupdated": "2023-03-16",
        "source": "1",
        "classification": "C",
        "value": "" 
      },
      "sex": {
        "lastupdated": "2023-03-16",
        "code": "M",
        "source": "1",
        "classification": "C",
        "desc": "MALE"  
      },
      "dob": {
        "lastupdated": "2023-03-16",
        "source": "1",
        "classification": "C",
        "value": {year:"",
        month:"",
        day:""} 
      },
      "residentialstatus": {
        "lastupdated": "2023-03-16",
        "code": "c", 
        "source": "1", 
        "classification": "C",
        "desc": "CITIZEN" 
      },
      "nationality": {
        "lastupdated": "2023-03-16",
        "code": "SG",
        "source": "1",
        "classification": "C",
        "desc": "SINGAPORE CITIZEN"
      },
      "mobileno": {
        "lastupdated": "2023-03-16",
        "source": "4",
        "classification": "C",
        "areacode": { "value": "" },
        "prefix": { "value": "" },
        "nbr": { "value": "" }
      },
      "email": {
        "lastupdated": "2023-03-16",
        "source": "4",
        "classification": "C",
        "value": ""
      },
      "regadd": {
        "country": { "code": "SG", "desc": "SINGAPORE" },
        "unit": { "value": "" },
        "street": { "value": "" },
        "lastupdated": "2023-03-16",
        "block": { "value": "" },
        "source": "1",
        "postal": { "value": "" },
        "classification": "C",
        "floor": { "value": "38" },
        "type": "SG",
        "building": { "value": "" }
      },
      "childrenbirthrecords": [
        {
          "birthcertno": { "value": "" }, 
          "lastupdated": "2023-03-16",
          "source": "1",
          "classification": "C",
          "name": { "value": "" }, 
          "sex": { "code": "M", "desc": "MALE" }, 
          "dob": { "value": {day:"",month:"", year:""} } 
        }
      ],
      "sponsoredchildrenrecords": []
    }
  }